import { Link, useLocation, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { formatMoney } from '../lib/format'
import { startPayment } from '../lib/payment'
import { storefrontApi } from '../lib/api'

type Purchase = { id: string; checkout_token: string; total: number; payment_method?: string }

export function OrderSuccess() {
  const { orderNumber } = useParams()
  const { state } = useLocation() as { state?: Purchase }
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null)
  const stored = (() => {
    try { return JSON.parse(sessionStorage.getItem(`gk-order-${orderNumber}`) || 'null') as Purchase | null }
    catch { return null }
  })()
  const purchase = stored || state

  useEffect(() => {
    if (!purchase?.id || !purchase.checkout_token) return
    let cancelled = false
    const check = async () => {
      try {
        const status = await storefrontApi.orderPaymentState(purchase.id, purchase.checkout_token)
        if (!cancelled) setPaymentStatus(status.payment_status)
      } catch { /* Status pode ficar indisponível temporariamente. */ }
    }
    void check()
    const timer = window.setInterval(() => void check(), 12000)
    return () => { cancelled = true; window.clearInterval(timer) }
  }, [purchase?.id, purchase?.checkout_token])

  const pay = async () => {
    if (!purchase) return
    setLoading(true); setError('')
    try {
      const { checkout_url } = await startPayment(purchase.id, purchase.checkout_token)
      window.location.assign(checkout_url)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Pagamento Efí indisponível.')
      setLoading(false)
    }
  }

  const isBolix = purchase?.payment_method === 'pix'
  const paid = paymentStatus === 'aprovado'
  const refunded = paymentStatus === 'estornado'
  const unavailable = paymentStatus === 'cancelado' || refunded
  return <div className="order-success">
    <span>{paid ? 'PAGAMENTO CONFIRMADO' : 'PEDIDO REGISTRADO'}</span>
    <h1>{paid ? 'TUDO CERTO!' : refunded ? 'PAGAMENTO ESTORNADO' : 'AGUARDANDO PAGAMENTO'}</h1>
    <p>Pedido <strong>#{orderNumber}</strong> recebido. {paid
      ? 'Seu pagamento foi confirmado. Aguarde a liberação da retirada pela GK Maison.'
      : 'A confirmação do pagamento será informada pela Efí Bank.'}</p>
    {purchase && <p>Total do pedido: <strong>{formatMoney(purchase.total)}</strong></p>}
    <section className="gk-pickup-info">
      <div>
        <h2>RETIRADA NA LOJA</h2>
        <strong>GK Maison · Sala 3</strong>
        <p>Rua Generoso Alves Vieira, 14<br />Jardim Santa Carolina, Sumaré/SP · CEP 13178-195</p>
        <small>Retire somente após a confirmação de que seu pedido está disponível na loja.</small>
      </div>
    </section>
    {error && <div className="form-error" role="alert">{error}</div>}
    {!paid && !unavailable && purchase && <button className="button button--dark" disabled={loading} onClick={pay}>
      {loading ? 'ABRINDO EFÍ...' : isBolix ? 'PAGAR COM PIX VIA BOLIX' : 'PAGAR COM CARTÃO NA EFÍ'}
    </button>}
    {!purchase && <p>Para retomar o pagamento, utilize o mesmo navegador e a mesma sessão em que o pedido foi criado, ou contate a loja.</p>}
    <p className="server-note">O retorno ao site não confirma o pagamento. No Pix via Bolix, a Efí poderá apresentar boleto também. A loja consulta o status atualizado no Supabase, com notificação verificada junto à Efí.</p>
    <Link className="button button--outline" to="/">VOLTAR À LOJA</Link>
  </div>
}
